import { render, staticRenderFns } from "./_TextPublication.vue?vue&type=template&id=dce67d94&scoped=true&"
import script from "./_TextPublication.vue?vue&type=script&lang=js&"
export * from "./_TextPublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce67d94",
  null
  
)

/* custom blocks */
import block0 from "./_TextPublication.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/render/project/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCardText})
